<template>
  <div>
    <hrms-staappr   :staappr='detail.staappr'
                    :nowLang="nowLang"
                    :currentDtereq="setDateOutput(currentDtereq)"
                    :currentNumseq="currentNumseq"
                    :currentCodempidDisp="false"
                    />

    <div class="box-func">
      <div class="box-topic border-color-skin">
        <i class="fa fa-envelope margin-r-5 color-skin"></i>
        <label class="color-skin">{{ labels['HRES88EC2']['30'] }}</label>
      </div>
      <div class="box-body">
        <div class="clearfix"></div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{ labels['HRES88EC2']['50'] }}</label>
              <div class="form-control readonly-field-color">{{detail.numreqst}}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{ labels['HRES88EC2']['30'] }} <span class="red">*</span></label>
              <hrms-lov-codcomp v-model="detail.codcomp"
                                  :nowLang="nowLang"
                                  v-validate="'required'"
                                  data-vv-value-path="inputValue"
                                  data-vv-name="codcomp"
                                  name="codcomp" />
              <div class="text-error" v-show="errors.has('codcomp')">{{ errors.first('codcomp') }}</div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{ labels['HRES88EC2']['40'] }} <span class="red">*</span></label>
              <hrms-lov v-model="detail.codpos"
                        lovType="codpos"
                        :nowLang="nowLang"
                        name="codpos"
                        v-validate="'required'"
                        :has-error="errors.has('codpos')"  />
              <div class="text-error" v-show="errors.has('codpos')">{{errors.first('codpos')}}</div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{ labels['HRES88EC2']['60'] }} <span class="red">*</span></label>
              <hrms-lov v-model="detail.codjob"
                        lovType="codjob"
                        :nowLang="nowLang"
                        name="codjob"
                        v-validate="'required'"
                        :has-error="errors.has('codjob')" />
              <div class="text-error" v-show="errors.has('codjob')">{{errors.first('codjob')}}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{ labels['HRES88EC2']['70'] }} <span class="red">*</span></label>
              <hrms-num-input class="text-center" v-model="detail.qtyreq"
                              :numLength='5'
                              :decimal='0'
                              name="qtyreq"
                              v-validate="'required'"
                              data-vv-name="qtyreq"
                              :has-error="errors.has('qtyreq')"   />

              <div class="text-error" v-show="errors.has('qtyreq')">{{ errors.first('qtyreq') }}</div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{ labels['HRES88EC2']['80'] }} <span class="red">*</span></label>
              <hrms-lov v-model="detail.codempmt"
                        lovType="codempmt"
                        :nowLang="nowLang"
                        name="codempl"
                        v-validate="'required'"
                        :has-error="errors.has('codempl')"  />
              <div class="text-error" v-show="errors.has('codempl')">{{errors.first('codempl')}}</div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{ labels['HRES88EC2']['90'] }} <span class="red">*</span></label>
              <hrms-datepicker  v-model="detail.dtereqm"
                                v-validate="'required|date_format:DD/MM/YYYY'"
                                data-vv-value-path="inputDate"
                                data-vv-name="dtereqm"
                                name="dtereqm"
                                :has-error="errors.has('dtereqm')" />
              <div class="text-error" v-show="errors.has('dtereqm')">{{errors.first('dtereqm')}}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{ labels['HRES88EC2']['100'] }}</label>
              <div class="input-group">
                <hrms-num-input class="text-center" v-model="detail.v_year"
                                :numLength='4'
                                :decimal='0'
                                name="v_year" />
                <span class="input-group-addon">{{ labels['HRES88EC2']['110'] }}</span>

                <hrms-num-input class="text-center" v-model="detail.v_mth"
                                :numLength='2'
                                :decimal='0'
                                name="v_mth"  />
                <span class="input-group-addon">{{ labels['HRES88EC2']['120'] }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{ labels['HRES88EC2']['130'] }}</label>
              <hrms-num-input class="align-right-input"
                              v-model="detail.amtincom"
                              :numLength='9'
                              name="amtincom" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{ labels['HRES88EC2']['140'] }}</label>
              <hrms-dropdown  v-model="detail.codrearq"
                              :options="dropdowns.codrearq[nowLang]"
                              name="codrearq" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <div class="form-group">
              <label>{{ labels['HRES88EC2']['150'] }}</label>
              <div class="row">
                <div class="form-group clearfix" style="margin-bottom: 0px;">
                  <div class="radio col-md-2" style="margin-bottom: 0px;">
                    <label><input type="radio" name="flgrecut" id="flgrecut_r1" value="I"  v-model="detail.flgrecut" />{{ labels['HRES88EC2']['160'] }}</label>
                  </div>
                  <div class="radio col-md-2" style="margin-bottom: 0px;">
                    <label><input type="radio" name="flgrecut" id="flgrecut_r2" value="E" v-model="detail.flgrecut" />{{ labels['HRES88EC2']['170'] }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>{{ labels['HRES88EC2']['190'] }}</label>
              <div class="row">
                <div class="form-group clearfix">
                  <div class="col-md-4">
                    <label>
                      <input type="checkbox" name="flgjob" id="flgjob" value="Y" v-model="flgjob" />
                      {{ labels['HRES88EC2']['200'] }}
                    </label>
                  </div>
                  <div class="col-md-8" v-if="flgjob" >
                    <textarea class="form-control textarea-text" maxlength="200"
                              v-model="detail.v_syncond1"
                              name="v_syncond1"
                              readonly="readonly" />
                    </textarea>
                  </div>
                  <div class="col-md-8" v-else >
                    <textarea class="form-control textarea-text"
                              name="v_syncond1"
                              readonly="readonly" />
                    </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group clearfix" style="margin-bottom: 0px;">
                  <div class="col-md-4">
                    <label>
                      <input type="checkbox" name="flgcond" id="flgcond" value="Y" v-model="flgcond" />
                      {{ labels['HRES88EC2']['210'] }}
                    </label>
                  </div>
                  <div class="col-md-8">
                    <hrms-logical-statement :listFields="listFields"
                                            :disableMode="!flgcond"
                                            :nowLang="nowLang"
                                            :lists="clearLogical"
                                            name="v_syncond"
                                            v-model="detail.v_syncond"
                                            v-validate="validateLogical"
                                            data-vv-value-path="inputValue"
                                            data-vv-name="Logical statement"
                                            :has-error="errors.has('Logical statement')" />
                    <div class="text-error" v-show="errors.has('Logical statement')">{{errors.first('Logical statement')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{ labels['HRES88EC2']['220'] }}</label>
              <textarea class="form-control textarea-text" maxlength="60" style="height: 114px;"
                        v-model="detail.desnote"
                        name="desnote" />
              </textarea>
              <div class="remark-limit-character">{{ dispLimitLabel(60) }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <div class="col-xs-8 col-md-6 col-sm-6  clear-padding">
          <button type="button" class="btn bg-dark-gray" @click="triggerToggle()" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
          <button type="button" class="btn bg-color-skin" @click="callSave()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { constLabels } from 'assets/js/constLabels.js'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres88e-detail',
  data () {
    return {
      flgjob: false,
      flgcond: false,
      validateLogical: '',
      clearLogical: []
    }
  },
  props: [ 'labels',
    'labelsButton',
    'detail',
    'toggle',
    'nowLang',
    'codempid',
    'descCodempid',
    'searchIndex',
    'indexSelected',
    'postHres88eDetailSave',
    'dropdowns',
    'descCodapp',
    'currentDtereq',
    'currentNumseq',
    'listFields',
    'eventBtn',
    'receivedHres88eDetailCodjob'
  ],
  watch: {
    detail () {
      this.flgjob = this.detail.flgjob === 'Y'
      this.flgcond = this.detail.flgcond === 'Y'
      this.$nextTick(function () {
        this.errors.clear()
      })
      this.clearLogical = []
    },
    'detail.dtereqm' () {
      if (this.eventBtn === 'add') {
        this.detail.dtereqm = moment().format('DD/MM/YYYY')
      }
    },
    'detail.codjob' () {
      this.callFindCodjob(this.detail.codjob)
    },
    flgcond () {
      if (this.flgcond) {
        this.validateLogical = 'required'
      } else {
        this.validateLogical = ''
        this.detail.v_syncond = {
          code: '',
          description: ''
        }
      }
    }
  },
  created () {
    this.flgjob = this.detail.flgjob === 'Y'
    this.flgcond = this.detail.flgcond === 'Y'
  },
  computed: {
    validateStaappr () {
      return (this.detail.staappr !== 'A' && this.detail.staappr !== 'Y' && this.detail.staappr !== 'N')
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    callFindCodjob (codjob) {
      let searchParams = {
        p_codjob: codjob
      }
      this.receivedHres88eDetailCodjob(searchParams)
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.detail.flgjob = this.flgjob ? 'Y' : 'N'
          this.detail.flgcond = this.flgcond ? 'Y' : 'N'
          let paramsSearchs = {
            p_codempid_query: this.codempid,
            p_dtereq: this.detail.dtereq,
            p_numseq: this.detail.numseq,
            dtereqst: this.searchIndex.dtereqst,
            dtereqen: this.searchIndex.dtereqen
          }
          this.postHres88eDetailSave({
            detail: this.detail,
            searchParams: paramsSearchs
          })
        }
      })
    },
    triggerToggle () {
      this.toggle('index')
    }
  }
}
</script>

<style lang="scss">
  .align-right-input {
    input {
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// detail.vue?167b2458